import React, { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import StructureOptionsContainer from '@Containers/StructureOptions/StructureOptionsContainer';
import { Dropdown } from '@els/els-react--dropdown';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';

import './BatchModalContent.scss';

const BATCH_STRUCTURE_UID = 'batch-modal';

function BatchModalContent(props) {
  const {
    search,
    searchContext,
    listOfContexts,
    batchFile,
    structures,
    setCurrentStructureOptions,
    setOverwriteOptions,
    overwriteOptions,
  } = props;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const onSearch = (context) => {
    search(context);
  };

  const openDropdown = useCallback(() => {
    if (isDropdownOpen) {
      dropdownRef.current.closeFlyout();
      setIsDropdownOpen(false);
    } else {
      dropdownRef.current?.flyoutRef?.current?.toggleVisibility(true);
      setIsDropdownOpen(true);
    }
  }, [isDropdownOpen]);

  const onOverwriteOptionsChange = (e) => {
    setOverwriteOptions(e.target.checked);
  };

  const getContextOptions = () =>
    listOfContexts?.map((context) => ({
      value: context?.displayName,
      label: context?.displayName,
      data: context,
    })) || [];

  const getStructureOptions = () => (
    <StructureOptionsContainer id={BATCH_STRUCTURE_UID} onCurrentOptionsChange={setCurrentStructureOptions} />
  );

  return (
    <div className="batch-modal__content">
      <div className="batch-modal__content_wrapper">
        <div className="batch-modal__content_title">{`Search for File "${batchFile.filename}" with ${batchFile.validQueriesCount} queries has been loaded`}</div>
        <div className="batch-modal__content_buttons">
          <div className="batch-modal__search-container">
            <Button
              disabled={!batchFile.validQueriesCount}
              size="small"
              onClick={() => {
                if (!searchContext) {
                  openDropdown();
                  return;
                }
                onSearch(searchContext);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  e.stopPropagation();
                }
              }}>
              {searchContext ? `Search ${searchContext.displayName}` : 'Search'}
            </Button>
            <div className="batch-modal__dropdown-container">
              <Dropdown
                label="Select search context"
                className="batch-modal__dropdown"
                shouldHideLabel
                ref={dropdownRef}
                options={getContextOptions()}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    onSearch(selectedOption.data);
                  }
                }}
                flyoutProps={{
                  placement: 'bottom-end',
                  pointerType: 'primary',
                }}
                trigger="button"
              />
            </div>
          </div>
        </div>
      </div>
      {structures?.length ? (
        <div className="batch-modal__content_wrapper batch-modal__content_optionsWrapper">
          {overwriteOptions && (
            <Flyout
              placement="bottom-start"
              pointerType="primary"
              flyout={getStructureOptions()}
              trigger="click"
              className="batch-modal__optionsDropdown"
              shouldCloseOnESC
              showCloseButton>
              <ButtonWithIcon size="small" sprite="ChevronDown" iconRight type="link" onClick={() => {}}>
                Options
              </ButtonWithIcon>
            </Flyout>
          )}
          <Checkbox
            className="batch-modal__checkbox"
            checked={overwriteOptions}
            onChange={onOverwriteOptionsChange}
            label={overwriteOptions ? '' : 'Overwrite existing options'}
          />
        </div>
      ) : null}
    </div>
  );
}
BatchModalContent.propTypes = {
  search: PropTypes.func.isRequired,
  searchContext: PropTypes.shape({ displayName: PropTypes.string }),
  listOfContexts: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
    })
  ),
  batchFile: PropTypes.shape({ filename: PropTypes.string, validQueriesCount: PropTypes.number }),
  structures: PropTypes.array,
  setCurrentStructureOptions: PropTypes.func.isRequired,
  setOverwriteOptions: PropTypes.func.isRequired,
  overwriteOptions: PropTypes.bool,
};
export default BatchModalContent;
